// src/components/home/HeroSection.jsx
import React from 'react';
import styles from './HeroSection.module.css';
import TypingText from '../includes/TypingText'; 
import heroStudentImage from '../../assets/imgs/NewBanner1.jpg'; 

const HeroSection = () => {
  return (
    <section className={styles.hero}>
        <div className={styles.heroContentLeft}>
           <h1 className={styles.heroTitle}>
             <TypingText />
          </h1>
          {/* <p className={styles.heroSubtitle}>
           We were put on this earth to help you squeeze every last shared value out of your career road-map.
           </p> */}

         </div>

      <div className={styles.heroImageRight}>
        {/* <img src={heroStudentImage} alt="Student learning" /> */}
        {/* Optional: Add the small bootcamp ad box floating on the image if you have that content */}
         {/* <div className={styles.bootcampAd}>
          <h4>Bootcamps</h4>
          <p>bspark.com</p>
          <button className={styles.applyNowButton}>Apply Now</button>
        </div>  */}
      </div>
    </section>
  );
};

export default HeroSection;